import React from 'react'
import PageTitle, { recordLabel, useAgencyName } from 'syft-acp-core/components/PageTitle'
import AgencyAccountsDetail from 'syft-acp-core/entities2/AgencyAccountsDetail'
import { AgenciesTrackingProvider } from './AgenciesTrackingProvider'
import { AgencySubNavigation } from './AgencySubNavigation'

export const AgencyAccountsView = ({ match: { params } }) => {
  const agencyIDParam = params.id ? Number(params.id) : undefined
  const accountId = params.account_id ? Number(params.account_id) : undefined
  const agencyName = useAgencyName(agencyIDParam)

  return (
    <PageTitle
      title={[
        // Match AgencyAccountsDetail, which branches on the same truthiness: with accountId 0
        // its heading reads 'Invite new member', so the tab must not claim to be viewing an
        // account. 0 is ACP's new-record sentinel (cf. EmployerAccountsNew passing id={0}).
        accountId ? `Account ${accountId}` : 'New account',
        recordLabel('Agency', agencyIDParam, agencyName),
      ]}
    >
      <AgencySubNavigation agencyID={agencyIDParam} agencyName={agencyName} />

      <AgenciesTrackingProvider agencyId={agencyIDParam} accountId={accountId}>
        <AgencyAccountsDetail accountId={accountId} id={accountId} agencyId={agencyIDParam} />
      </AgenciesTrackingProvider>
    </PageTitle>
  )
}
